/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IButtonProps, IButtonStyles } from '@fluentui/react/lib/Button';
import { ITooltipStyles } from '@fluentui/react/lib/Tooltip';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { TooltipProps } from 'src/modules/labeling/components/Tooltip';

export const commandBarButtonInLuisToolTipStyles = classNamesFunction<IButtonProps, IButtonStyles>()({
    root: { height: '100%' }
});

export const commandBarButtonInLuisToolTipStylesInOverFlow = classNamesFunction<IButtonProps, IButtonStyles>()({
    root: { height: '36px', padding: '0px 4px', display: 'block', textAlign: 'left', width: '100%' },
    icon: { fontSize: '20px' }
});

export const getRBACTooltipStyles = () =>
    classNamesFunction<TooltipProps, ITooltipStyles>()({
        root: { selectors: { '*': { cursor: 'not-allowed' } } }
    });

export const getCommandBarButtonStyles = (renderedInOverFlow: boolean) =>
    renderedInOverFlow ? commandBarButtonInLuisToolTipStylesInOverFlow : commandBarButtonInLuisToolTipStyles;
